import dayjs from "dayjs"

export const clearFilterData = {
  AptTmSt: null,
  AptTmEn: null
}

export const initFilterData = {
  AptTmSt: dayjs().add(-10, "day").format("YYYY-MM-DD 00:00:00"),
  AptTmEn: dayjs().add(3, "day").format("YYYY-MM-DD 23:59:59")
}